/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CustomerShoppingCartPurchaseMissionDto from './CustomerShoppingCartPurchaseMissionDto';
import PaginationModel from './PaginationModel';

/**
 * The SearchingQueryResponseModelCustomerShoppingCartPurchaseMissionDto model module.
 * @module model/SearchingQueryResponseModelCustomerShoppingCartPurchaseMissionDto
 * @version v1.0.0
 */
class SearchingQueryResponseModelCustomerShoppingCartPurchaseMissionDto {
    /**
     * Constructs a new <code>SearchingQueryResponseModelCustomerShoppingCartPurchaseMissionDto</code>.
     * @alias module:model/SearchingQueryResponseModelCustomerShoppingCartPurchaseMissionDto
     */
    constructor() { 
        
        SearchingQueryResponseModelCustomerShoppingCartPurchaseMissionDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SearchingQueryResponseModelCustomerShoppingCartPurchaseMissionDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SearchingQueryResponseModelCustomerShoppingCartPurchaseMissionDto} obj Optional instance to populate.
     * @return {module:model/SearchingQueryResponseModelCustomerShoppingCartPurchaseMissionDto} The populated <code>SearchingQueryResponseModelCustomerShoppingCartPurchaseMissionDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchingQueryResponseModelCustomerShoppingCartPurchaseMissionDto();

            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = PaginationModel.constructFromObject(data['pagination']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], [CustomerShoppingCartPurchaseMissionDto]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/PaginationModel} pagination
 */
SearchingQueryResponseModelCustomerShoppingCartPurchaseMissionDto.prototype['pagination'] = undefined;

/**
 * search result list
 * @member {Array.<module:model/CustomerShoppingCartPurchaseMissionDto>} result
 */
SearchingQueryResponseModelCustomerShoppingCartPurchaseMissionDto.prototype['result'] = undefined;






export default SearchingQueryResponseModelCustomerShoppingCartPurchaseMissionDto;

